<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <h3 [i18nKey]="'studies.exceptional.result.exceptional.incomes'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.exceptional.result.exceptional.incomes'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.exceptional.result.incomes'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.exceptional.result.layout.selling.incomes'"></td>
            <td class="_number">{{study.layoutSellingIncome | number:'1.2'}}</td>

        </tr>
        <tr>
            <td [i18nKey]="'studies.exceptional.result.other.exceptional.incomes'"></td>
            <td class="_number">{{study.otherExceptionalIncomes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.exceptional.result.total.incomes'"></td>
            <td class="_number">{{study.totalExceptionalIncome | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="32"></kiwi-spacer>

    <h3 [i18nKey]="'studies.exceptional.result.exceptional.charges'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.exceptional.result.exceptional.charges'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.exceptional.result.charges'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.exceptional.result.layout.selling.charges'"></td>
            <td class="_number">{{study.layoutValueSold | number:'1.2'}}</td>

        </tr>
        <tr>
            <td [i18nKey]="'studies.exceptional.result.other.exceptional.charges'"></td>
            <td class="_number">{{study.otherNonRecurringCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.exceptional.result.total.charges'"></td>
            <td class="_number">{{study.totalNonRecurringCharge | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>
    <kiwi-spacer [size]="16"></kiwi-spacer>
    <p [i18nKey]="'studies.exceptional.result.description'"></p>
</div>
